import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Language = 'ar' | 'en';

interface UIState {
  /** اللغة الحالية (ar/en) */
  language: Language;
  setLanguage: (lang: Language) => void;
  /** القائمة الجانبية مفتوحة على الموبايل؟ */
  mobileNavOpen: boolean;
  setMobileNavOpen: (open: boolean) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      language: 'ar',
      setLanguage: (language) => set({ language }),
      mobileNavOpen: false,
      setMobileNavOpen: (mobileNavOpen) => set({ mobileNavOpen }),
    }),
    { name: 'img-ui' },
  ),
);
